// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td.table-cell-droppable-shift:hover{background:rgba(0,0,0,.2)}", ""]);
// Exports
module.exports = exports;
